<app-navbar></app-navbar>

<div class="breadcrumb">
    <a href="/">YouPrice</a>  &rarr; 
    <strong>Ce que nos clients disent de nous</strong>
</div>

<section class="reviews-section">
  <div class="reviews-header">
    <h2 class="title">
      Ce que nos clients <span class="text-blue">disent de nous</span>
    </h2>
    <div class="global-rating">
      <div class="score">
        <span class="score-large">4,5</span>
        <span class="score-small">/ 5</span>
      </div>
      <div class="stars-blue">
        ★★★★<span class="half-star">★</span>
      </div>
      <p class="subtitle">Basé sur plus de 6 000 avis clients authentiques</p>
    </div>
  </div>

  <div class="carousel-viewport" 
       (touchstart)="onTouchStart($event)" 
       (touchend)="onTouchEnd($event)">
       
    <div class="carousel-inner" [style.transform]="getTransform()">
      
   @for (review of reviews; track review.name; let i = $index) {
       <div class="review-card" 
             [class.is-center]="itemsPerPage === 3 && i === (currentPage * itemsPerPage) + 1"
             [style.flex]="getCardFlex()">
          <div class="card-header">
            <div class="user-info">
              <img [src]="review.avatar" [alt]="review.name" class="avatar" />
              <span class="user-name">{{ review.name }}</span>
            </div>
            <div class="stars-yellow">
              @for (star of [1, 2, 3, 4, 5]; track star) {
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <path d="M16.3802 7.17549C16.8423 6.71263 16.5811 5.92098 15.9343 5.82397L11.6954 5.18812C11.4341 5.14894 11.2093 4.9829 11.095 4.74476L9.21426 0.827088C8.92484 0.224188 8.06639 0.224187 7.77697 0.827086L5.89625 4.74477C5.78194 4.9829 5.55708 5.14894 5.29586 5.18812L1.05508 5.82424C0.408639 5.9212 0.147249 6.71218 0.608618 7.17524L1.67983 8.25037L3.99958 10.5701L3.32199 14.5958L3.19911 15.3331C3.0901 15.9872 3.78082 16.4807 4.36427 16.1656L8.11678 14.1388C8.3532 14.0111 8.63804 14.0111 8.87445 14.1388L12.6251 16.1646C13.2089 16.4799 13.8999 15.9857 13.7901 15.3313L13.0595 10.9748C13.0169 10.7208 13.0996 10.462 13.2815 10.2797L16.3802 7.17549Z" 
                        [attr.fill]="star <= review.stars ? '#FFCC00' : '#E0E0E0'"/>
                  <path d="M3.99958 10.5701L1.6878 8.25037M3.99958 10.5701L1.67983 8.25037L0.608618 7.17524C0.147249 6.71218 0.408639 5.9212 1.05508 5.82424L5.29586 5.18812C5.55708 5.14894 5.78194 4.9829 5.89625 4.74477L7.77697 0.827086C8.06639 0.224187 8.92484 0.224188 9.21426 0.827089L11.095 4.74476C11.2093 4.9829 11.4341 5.14894 11.6954 5.18812L15.9343 5.82397C16.5811 5.92098 16.8423 6.71263 16.3802 7.17549L13.2815 10.2797C13.0996 10.462 13.0169 10.7208 13.0595 10.9748L13.7901 15.3313C13.8999 15.9857 13.2089 16.4799 12.6251 16.1646L8.87445 14.1388C8.63804 14.0111 8.3532 14.0111 8.11678 14.1388L4.36427 16.1656C3.78082 16.4807 3.0901 15.9872 3.19911 15.3331L3.32199 14.5958L3.99958 10.5701Z" 
                        stroke="#1C1C1C" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              }
            </div>
          </div>
          <div class="card-body">
            @for (p of review.paragraphs; track $index) {
              <p>{{ p }}</p>
            }
          </div>
        </div>
      }

    </div>
  </div>

  <div class="pagination-dots">
    @for (page of pages; track page) {
      <span class="dot" [class.active]="page === currentPage" (click)="goToPage(page)"></span>
    }
  </div>

  <div class="reviews-footer">
    <div class="trustpilot-logo">
      <span class="trustpilot-star"><svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
  <path d="M4.78125 23.75L6.8125 14.9688L0 9.0625L9 8.28125L12.5 0L16 8.28125L25 9.0625L18.1875 14.9688L20.2188 23.75L12.5 19.0938L4.78125 23.75Z" fill="#00B67A"/>
</svg></span> <strong>Trustpilot</strong>
    </div>
    <a href="https://fr.trustpilot.com/review/www.youprice.fr" class="btn-primary">
      Lisez nos plus de 6 000 avis <span class="arrow">→</span>
    </a>
  </div>
</section>

<app-always-there></app-always-there>
<app-small-faq></app-small-faq>
<app-interest-you></app-interest-you>
<app-footer></app-footer>